<template>
  <div>
    <h1>404 not found</h1>
  </div>
</template>
<script>
export default {      
  name: 'notfoundcomponent',
  data: function () {
    return {
      
    }
  },
  methods: {    
  },created: function(){    
    
  }
}
</script>
